import { html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import '../katapult-photo/katapult-photo.js';
import '../katapult-photo/katapult-photo-viewer.js';
import '../katapult-photo/annotation-editor.js';
import '../katapult-elements/katapult-button.js';
import '@polymer/paper-toast/paper-toast.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { Path } from '../../modules/Path.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings';
import { TraverseMarkers } from '../../modules/TraverseMarkers.js';
import { RunOnChildren } from '../../modules/RunOnChildren';
import { ToArray } from '../../modules/ToArray.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import './tags/model-item-tag-selector.js';

export class KatapultRoutineEditor extends mixinBehaviors([DefaultComputedBindings], KatapultEditorTemplate) {
  static get template() {
    return html`
      ${super.style}
      <style>
        :host {
          padding: 0;
        }
        .body {
          margin-left: 48px;
        }
        katapult-drop-down,
        paper-input {
          flex-grow: 1;
        }
        katapult-drop-down,
        paper-checkbox {
          /* --primary-text-color: var(--paper-grey-700); */
          --primary-color: var(--secondary-color);
        }
        paper-tabs {
          --paper-tabs-selection-bar-color: var(--secondary-color);
          --paper-tab-ink: var(--secondary-color);
        }
        paper-tab {
          --paper-tab: {
            font-size: 12pt;
            font-weight: normal;
          };
          --paper-tab-content-focused: {
            font-weight: normal;
          };
        }

        paper-header-content {
          background-color: white;
          color: var(--paper-grey-800);
        }
        paper-header-content paper-input {
          text-transform: none;
        }

        [drag-handle]:hover {
          cursor: move;
        }

        /********************************/
        #container {
          display: flex;
          height: 100%;
        }
        #settings {
          width: 800px;
          overflow-y: auto;
          padding: 48px;
        }
        #photo {
          display: flex;
          height: 100%;
          width: 100%;
        }
        #viewer {
          flex-grow: 1;
          height: 100%;
          width: 100%;
        }
        #number {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 8px;
          width: 8px;
          font-size: 0;
          background: var(--paper-grey-400);
          color: white;
          border-radius: 100%;
          flex-shrink: 0;
          transition: all 0.3s;
        }
        #title {
          text-transform: none;
          font-size: 14pt;
          color: var(--paper-grey-600);
          padding-left: 0;
          flex-grow: 0;
          flex-basis: auto;
        }
        #additionalInformationContainer {
          display: flex;
          flex-direction: column;
          width: 400px;
          color: var(--primary-text-color-faded);
          margin-left: 48px;
          gap: 16px;
        }
        #examplePhotoContainer {
          display: flex;
          overflow: hidden;
          height: 360px;
          box-sizing: border-box;
          border: 1px solid rgba(0 0 0 / 12%);
          border-radius: 16px;
        }
      </style>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}"> </katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/trace_models" data="{{traceModels}}"> </katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/routines" data="{{routines}}"> </katapult-firebase-worker>
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/input_model_groups" data="{{inputModelGroups}}">
      </katapult-firebase-worker>

      <!-- K logic editor dialog -->
      <katapult-dialog-legacy
        id="kLogicEditorDialog"
        draggable
        min-width="500"
        no-cancel-on-esc-key=""
        no-cancel-on-outside-click=""
        entry-animation="scale-up-animation"
      >
        <div slot="title" secondary-color style="text-transform:uppercase;">[[kLogicDialogInfo.title]]</div>
        <div slot="body" style="display: flex; flex-direction: column; gap: 16px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <material-icon icon="[[kLogicDialogInfo.icon]]"></material-icon>
            <div style="font-size: 16px; font-weight: 500;">[[kLogicDialogInfo.subtitle]]</div>
          </div>
          <div>[[kLogicDialogInfo.body]]</div>
          <k-logic-editor schema="[[kLogicDialogInfo.schema]]" block="{{kLogicDialogInfo.block}}" expand-editor></k-logic-editor>
        </div>
        <div slot="buttons">
          <katapult-button dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--secondary-color)" dialog-confirm on-click="kLogicDialogConfirm"
            >[[kLogicDialogInfo.confirmText]]</katapult-button
          >
        </div>
      </katapult-dialog-legacy>

      <paper-toast id="toast"></paper-toast>

      <div id="container">
        <div id="settings">
          <sl-alert open="[[showConstructionSpecAlert]]">
            <katapult-icon slot="icon" icon="notifications"></katapult-icon>
            <span
              >This photo routine was generated by a construction spec. To edit this routine please use the
              <a
                href="[[getConstructionSpecEditorLink(modelSpaceDetails.$key, _itemData.construction_spec_key)]]"
                on-click="openConstructionSpec"
                >Construction Specs Editor</a
              >.</span
            >
          </sl-alert>
          <paper-row header>
            <paper-cell icon>
              <div id="number"></div>
            </paper-cell>
            <paper-cell id="title">Toolsets</paper-cell>
          </paper-row>
          <div style="width: 400px; color: var(--primary-text-color-faded); margin-left:48px;">
            <paper-table light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    items="[[inputModelGroups]]"
                    label-function="[[camelCaseKey]]"
                    value-path="$key"
                    label="Select a Toolset"
                    no-label-float
                    on-selected-changed="toolsetSelectedChanged"
                    disabled="[[editingDisabled]]"
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
            <template is="dom-if" if="[[nullify(_itemData.toolsets, _itemData.toolsets.*)]]">
              <paper-table style="margin-top: 24px;" rounded outline white dividers>
                <template is="dom-repeat" items="{{toArray(_itemData.toolsets, _itemData.toolsets.*)}}">
                  <paper-row>
                    <paper-cell>[[camelCase(item.$key)]]</paper-cell>
                    <paper-cell icon-button>
                      <katapult-button
                        iconOnly
                        noBorder
                        icon="delete"
                        on-click="removeFromToolset"
                        disabled="[[editingDisabled]]"
                      ></katapult-button>
                    </paper-cell>
                  </paper-row>
                </template>
              </paper-table>
            </template>
          </div>

          <paper-row style="margin-top:20px;" header>
            <paper-cell icon>
              <div id="number"></div>
            </paper-cell>
            <paper-cell id="title">Additional Information</paper-cell>
          </paper-row>

          <div id="additionalInformationContainer">
            <paper-textarea label="Description" value="{{_itemData.description}}" disabled$="[[editingDisabled]]"></paper-textarea>

            <template is="dom-if" if="[[hasExampleImage(_itemData.*, constructionSpecMode)]]">
              <div style="display: flex; flex-direction: column; gap: 8px;">
                <div style="display: flex; gap: 8px; justify-content: space-between; align-items: center;">
                  <div>Example Image</div>
                  <div style="display: flex; gap: 8px;">
                    <sl-tooltip content="Open example image in new tab">
                      <katapult-button iconOnly noBorder icon="open_in_new" on-click="openImageFile"></katapult-button>
                    </sl-tooltip>
                    <sl-tooltip content="Remove example image">
                      <katapult-button iconOnly noBorder icon="delete" on-click="removeImageFile"></katapult-button>
                    </sl-tooltip>
                  </div>
                </div>
                <div id="examplePhotoContainer">
                  <katapult-photo src="[[exampleImagePreviewSrc]]" zoom></katapult-photo>
                </div>
              </div>
            </template>
            <template is="dom-if" if="[[!hasExampleImage(_itemData.*, constructionSpecMode)]]">
              <katapult-button icon="add_photo_alternate" on-click="openImageInput" disabled="[[editingDisabled]]"
                >Upload Example Image</katapult-button
              >
            </template>
            <input id="imageInput" style="display:none;" type="file" accept="image/*" on-change="imageFileSelected" />
          </div>

          <paper-row class="header">
            <paper-cell icon>
              <div id="number"></div>
            </paper-cell>
            <paper-cell id="title">Tags</paper-cell>
          </paper-row>
          <div style="width: 400px; margin-left:48px;">
            <paper-table light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <model-item-tag-selector
                    style="width: -webkit-fill-available;"
                    model-path="[[modelSpaceDetails.path]]"
                    modelCategory="photo_routines"
                    item-key="[[itemKey]]"
                    tags="[[_itemData.tags]]"
                    on-change="tagSelectorChangeHandler"
                    mayAddTags
                    look-like-paper-element
                  ></model-item-tag-selector>
                </paper-cell>
              </paper-row>
            </paper-table>
          </div>
          <!-- Checkbox which allows you to remove all the limits on which markers can be nested together -->
          <!--<paper-checkbox style="width: 400px; color: var(--primary-text-color-faded); margin-left:48px; margin-top: 20px;" checked="{{removeLimits}}">Remove Limits on Marker Nesting</paper-checkbox>-->
          ${super.createItemContainer}
        </div>
        <div id="photo">
          <iron-a11y-keys target="{{getItemById('viewer')}}" keys="esc" on-keys-pressed="finishTrace"></iron-a11y-keys>
          <iron-a11y-keys target="{{getItemById('viewer')}}" keys="~ \` -" on-keys-pressed="startTrace"></iron-a11y-keys>
          <template is="dom-if" if="{{newData}}">
            <annotation-editor
              id="newDataEditor"
              value="{{newData.value}}"
              property="{{newData.property}}"
              input-models="{{inputModels}}"
              other-attributes="{{otherAttributes}}"
              user-group="{{userGroup}}"
              on-delete="clearNewData"
              on-save="newDataChange"
              on-submit="editorSubmit"
              editable=""
              on-remove-attribute=""
              job-creator="[[modelSpaceDetails.$key]]"
            >
              <iron-a11y-keys keys="alt+d" on-keys-pressed="clearNewData"></iron-a11y-keys>
            </annotation-editor>
          </template>
          <katapult-photo-viewer
            id="viewer"
            photo-data="[[photoData]]"
            remove-limits="[[removeLimits]]"
            tabindex="0"
            src="[[blankPhotoUrl]]"
            annotations
            allow-tracing
            zoom
            auto-resize
            annotation-editor-show-menu
            annotations-as-markers
            trace-listeners="{{traceListeners}}"
            other-attributes="[[otherAttributes]]"
            input-models="{{inputModels}}"
            single-click-list="[[getSingleClickList(routines, inputModels)]]"
            user-group="{{userGroup}}"
            on-viewer-photo-tap="tapPhoto"
            on-choose-temporary-input-type="chooseNewInput"
            on-data-change="photoDataChange"
            on-data-change-routine="photoDataChange"
            on-constraint-blurred="getPhotoData"
            show-constraint-input="[[constructionSpecMode]]"
            on-prompt-constraint-relative-to-selection="promptConstraintRelativeToSelection"
            show-k-logic-button="[[showKLogicButton(enabledFeatures, type)]]"
            on-open-k-logic-editor="openKLogicEditor"
            on-remove-attribute="photoDataChange"
            on-child-added="childAdded"
            on-child-removed="childRemoved"
            on-commit-trace="traceChange"
            on-remove-trace="removeTrace"
            on-delete-trace="deleteTrace"
            on-marker-selected="markerSelected"
            job-creator="[[modelSpaceDetails.$key]]"
            published="[[editingDisabled]]"
          >
          </katapult-photo-viewer>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      type: {
        type: String,
        value: 'routine'
      },
      blankPhotoUrl: {
        type: String,
        value: 'https://storage.googleapis.com/katapult-pro-shared-files/photos/blank_node_photo.png'
      },
      photoData: {
        type: Object,
        value: () => ({})
      },
      traceListeners: {
        type: Object,
        value: () => ({ traceData: {} })
      },
      localTraceListeners: {
        type: Object,
        value: () => ({ traceData: {} })
      },
      removeLimits: {
        type: Boolean,
        value: false
      },
      activeTraceId: {
        type: String,
        value: null
      },
      traceCount: {
        type: Number,
        value: -1
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      },
      constructionSpecMode: {
        type: Boolean,
        value: false
      },
      exampleImagePreviewSrc: {
        type: String,
        value: ''
      },
      editingDisabled: {
        type: Boolean,
        value: false,
        notify: true
      }
    };
  }

  static get observers() {
    return [
      'getPhotoData(_itemData, inputModels, traceModels)',
      'updateExampleImagePreviewSrc(_itemData.file, constructionSpecMode, _itemData.icons.length, _itemData.example_image_id)',
      'disableEditingIfConstructionSpecInPhotoRoutineEditor(constructionSpecMode, _itemData.category)'
    ];
  }

  constructor() {
    super();

    this.constructionSpecMode = false;
    this.modelSpaceDetails = null;
  }

  connectedCallback() {
    super.connectedCallback();

    this.customLogicRoutineValuesFlagListener = addFlagListener('custom_logic_routine_values', (enabled) => {
      this.set('enabledFeatures.custom_logic_routine_values', enabled);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    removeFlagListener('custom_logic_routine_values', this.customLogicRoutineValuesFlagListener);
  }

  ready() {
    super.ready();
    this.labelAllowAllCharacters = true;
  }

  labelChanged(label) {
    this.set('_itemData.name', label);
  }

  disableEditingIfConstructionSpecInPhotoRoutineEditor() {
    if (!this.constructionSpecMode && this._itemData?.category == 'Construction Specs') {
      this.editingDisabled = true;
      this.showConstructionSpecAlert = true;
    } else {
      this.editingDisabled = false;
      this.showConstructionSpecAlert = false;
    }
  }

  getConstructionSpecEditorLink() {
    if (!this.modelSpaceDetails || !this._itemData) return;
    return `${location.pathname}#${this.modelSpaceDetails.$key}/construction_specs/${this._itemData.construction_spec_key}`;
  }

  openConstructionSpec(e) {
    const aTagHref = e.currentTarget.href;
    if (!aTagHref) return;
    window.open(aTagHref, '_blank');
  }

  // override
  updateCanSaveItem() {
    super.updateCanSaveItem.apply(this, arguments);
    // Extra check to see if a routine has items.  If it doesn't the user should not be able to save.
    this.canSaveItem = !this.editingDisabled && this.canSaveItem && !this.noItems;
  }

  // override
  async beforeSave() {
    if (!this.constructionSpecMode) return;

    // If we are in construction spec mode and we don't have a routine key, we need to create one
    if (!this._itemData.routine_key) {
      this._itemData.routine_key = globalThis.FirebaseWorker.ref().push().key;
    }
  }

  // override
  async afterSave() {
    if (!this.constructionSpecMode) return;
    // A list of update promises
    const updatePromises = [];

    const modelsRef = globalThis.FirebaseWorker.ref(`${this.modelSpaceDetails.path}/models`);
    const constructionSpecAutoSyncedPicklistRef = modelsRef.child('attributes/construction_spec/picklists/auto_synced');
    const autoSyncedPicklist = (await constructionSpecAutoSyncedPicklistRef.once('value')).val() ?? [];

    // If we have a routine key to delete, then we just deleted the construction spec and need to delete its routine
    if (this.routineKeyToDelete) {
      const indexToRemove = autoSyncedPicklist.findIndex((option) => option.value === this.keyOfConstructionSpecBeingDeleted);
      if (indexToRemove !== -1) {
        autoSyncedPicklist.splice(indexToRemove, 1);
        updatePromises.push(constructionSpecAutoSyncedPicklistRef.set(autoSyncedPicklist));
      }

      // Remove the routine itself
      updatePromises.push(modelsRef.child(`routines/${this.routineKeyToDelete}`).remove());

      await Promise.all(updatePromises);
      this.keyOfConstructionSpecBeingDeleted = null;
      this.routineKeyToDelete = null;
      return;
    }

    // Update the auto-synced picklist
    const indexToUpdate = autoSyncedPicklist.findIndex((option) => option.value === this._itemData.$key);
    if (indexToUpdate !== -1) autoSyncedPicklist[indexToUpdate].label = this._itemData.name;
    else autoSyncedPicklist.push({ label: this._itemData.name, value: this._itemData.$key });

    // Sort the picklist alphabetically and save it
    autoSyncedPicklist.sort((a, b) => a.label.localeCompare(b.label));
    updatePromises.push(constructionSpecAutoSyncedPicklistRef.set(autoSyncedPicklist));

    // If we are in construction spec mode we need to save a routine for this construction spec
    const newRoutine = {
      category: 'Construction Specs',
      construction_spec_key: this._itemData.$key,
      description: this._itemData.description ?? null,
      last_modified: firebase.database.ServerValue.TIMESTAMP,
      name: this._itemData.name,
      toolsets: this._itemData.toolsets ?? null
    };

    // Loop through the construction spec items and update them to work with the new routine
    const items = this.addRoutineRelativePropertiesToConstructionSpecItems(this._itemData.items);
    // Remove unnecessary properties from the items
    for (const item of items) {
      delete item._constraints;
      delete item._reference_key;
    }
    // Add a construction spec photo chip to the routine
    items.unshift({
      attributes: {
        construction_spec: this._itemData.name
      },
      type: 'construction_spec'
    });
    newRoutine.items = items;

    // Save the routine (the routine key is generated in beforeSave)
    updatePromises.push(modelsRef.child(`routines/${this._itemData.routine_key}`).set(newRoutine));

    // Wait for all updates to finish
    await Promise.all(updatePromises);
  }

  // override
  delete() {
    if (this.constructionSpecMode) {
      this.routineKeyToDelete = this._itemData.routine_key;
      this.keyOfConstructionSpecBeingDeleted = this._itemData.$key;
    }
    return super.delete();
  }

  // override
  updateItemNewKeyExists() {
    /* Normally, we only want to create a new item key if the keys don't match and the key doesn't already exist in categoryData (found in katapult-editor-template).  For routines, we also don't want to create the key if
    it exists within the input models.  So, if the key is already invalid from the normal checks (true), its value remains the same after this check.  If it's not (false), then it will become invalid if the key exists within input models */
    super.updateItemNewKeyExists.apply(this, arguments);
    this.itemNewKeyExists = this.itemNewKeyExists || this.get(`inputModels.${this.get('_itemData.$key')}`) != null;
  }

  /**
   * Adds routine-relative properties to the given construction specification items.
   *
   * @param {object[]} constructionSpecItems - The array of construction specification items to process.
   * @param {boolean} [computedForPhotoData] - Used to determine how to compute the relative_to_index
   * @returns {object[]} A new array of construction specification items with added routine-relative properties.
   */
  addRoutineRelativePropertiesToConstructionSpecItems(constructionSpecItems, computedForPhotoData) {
    if (!this.constructionSpecMode)
      throw new Error('addRoutineRelativePropertiesToConstructionSpecItems should only be called in construction spec mode');

    const items = structuredClone(constructionSpecItems);
    for (const item of items) {
      // Get the first constraint for the item
      const constraint = item._constraints ? Object.values(item._constraints)[0] : null;
      if (!constraint || !constraint.relative_to) continue;

      // Set the relative distance
      item.relative_distance = constraint.standard_clearance;
      // Set the relative to index
      item.relative_to_index =
        constraint.relative_to === '$POLE_TOP'
          ? '$POLE_TOP'
          : items.findIndex((item) => item._reference_key === constraint.relative_to) + (!computedForPhotoData ? 1 : 0);
    }
    return items;
  }

  toArray(x) {
    return ToArray(x);
  }

  getSingleClickList(routines, inputModels) {
    // Wait for routines and inputModels to be loaded
    if (!routines || !inputModels) return [];

    var list = [];
    //push items from inputModels
    for (const [key, inputModel] of Object.entries(inputModels ?? {})) {
      if (list.find((x) => x?.value.toLowerCase() == key.toLowerCase())) continue;
      list.push({ value: key, label: inputModel.name ?? CamelCase(key) });
    }
    //push items from routines
    for (const [key, routine] of Object.entries(routines ?? {})) {
      //check to see if this item has been added in some fashion to the list array
      if (list.find((x) => x?.value.toLowerCase() == key.toLowerCase())) continue;
      list.push({ value: key, label: routine.name ?? CamelCase(key) });
    }
    //sort alphabetically
    list.sort((a, b) => a.label.localeCompare(b.label));
    return list;
  }

  getPhotoData() {
    let photoData = {};
    let routineItems = this.get('_itemData.items');

    // set a default pole top height
    const defaultPoleTopHeightInInches = 600;

    // The percentages of the top and bottom of the blank pole photo
    // TODO (03/18/2023): We need to update these percentages when we replace the blank pole photo with a 3D rendered pole
    const poleTopHeightPercentage = 11;
    const poleBottomHeightPercentage = 93;

    // if we are in construction mode, set up the photo data differently
    if (this.constructionSpecMode) {
      // set the routineItems to be the items translated from the construction spec data
      const routineItemsFromConstructionSpec = this.addRoutineRelativePropertiesToConstructionSpecItems(routineItems ?? [], true);
      if (routineItemsFromConstructionSpec) routineItems = routineItemsFromConstructionSpec;

      // automatically add a pole top to the photo data
      photoData.pole_top = {
        'i-0': { pixel_selection: [{ percentX: 50, percentY: poleTopHeightPercentage }], _uneditable: true }
      };
    }
    if (!routineItems) return;

    // specifies whether the current photo input can be saved.  It should only be able to be saved if there are items
    if (routineItems?.length == 0) this.noItems = true;
    else this.noItems = false;

    if (Array.isArray(routineItems) && this.inputModels && this.traceModels) {
      let numItems = routineItems.length;
      //removes chips from item count so blank markers aren't created in the photo input editor
      routineItems.forEach((item, index) => {
        if (item && SquashNulls(this.inputModels, item.type, '_attributes', 'pixel_selection') == '') {
          numItems--;
        }
      });

      //reset traceListeners, active trace, and traceCount to be built by the routineToMarker method
      this.localTraceListeners.traceData = {};
      this.traceCount = -1;
      this.clearRoutineTraceData(routineItems);

      // get a list of markers with relative distances and sort them
      const markersWithRelativeDistances = routineItems.filter((item) => item != null && item?.relative_distance != null);
      const sortedMarkersWithRelativeDistances = markersWithRelativeDistances.sort((a, b) => {
        // items where the "relative_to_index" marker is the pole top belong first
        // if an item doesn't have a "relative_to_index", sort it to the end
        const aRelativeToIndex = a.relative_to_index == '$POLE_TOP' ? -1 : (a.relative_to_index ?? 1000);
        const bRelativeToIndex = b.relative_to_index == '$POLE_TOP' ? -1 : (b.relative_to_index ?? 1000);
        return aRelativeToIndex - bRelativeToIndex;
      });

      // get markers without relative distances
      const startingMarkersWithoutRelativeDistances = routineItems.filter((item) => item != null && item?.relative_distance == null);

      // add markers from items that have relative distances
      const placementDataForRelativeMarkers = {
        placingMarkersWithRelativeDistance: true,
        poleHeightInInches: defaultPoleTopHeightInInches,
        poleTopPercentageFromBottom: 100 - poleTopHeightPercentage,
        poleGroundPercentageFromBottom: 100 - poleBottomHeightPercentage,
        markersWithoutRelativeDistances: [...startingMarkersWithoutRelativeDistances],
        lowestPlacedMarkerHeightPercentage: null
      };
      if (sortedMarkersWithRelativeDistances.length != 0)
        sortedMarkersWithRelativeDistances.forEach((item, index) =>
          this.routineToMarker(item, index, photoData, placementDataForRelativeMarkers)
        );

      // prepare to add markers that have manual heights
      const markersWithManualHeights = placementDataForRelativeMarkers.markersWithoutRelativeDistances;
      const lowestPlacedMarkerHeightPercentage = placementDataForRelativeMarkers.lowestPlacedMarkerHeightPercentage;
      const placementDataForMarkersWithManualHeights = {
        poleTopHeightPercentage,
        poleBottomHeightPercentage,
        markersWithoutRelativeDistances: markersWithManualHeights,
        lowestPlacedMarkerHeightPercentage,
        currentManualHeightMarkerPlacementCount: 0
      };

      // calculate where to start the indices for the markers without relative distances
      const relativeMarkersWithErrorsCount = markersWithManualHeights.length - startingMarkersWithoutRelativeDistances.length;
      const offset = markersWithRelativeDistances.length - relativeMarkersWithErrorsCount;

      // add the markers with manual heights
      if (markersWithManualHeights.length != 0) {
        markersWithManualHeights.forEach((item, index) => {
          const offsetIndex = index + offset;
          this.routineToMarker(item, offsetIndex, photoData, placementDataForMarkersWithManualHeights);
        });
      }
    }

    this.photoData = {
      photofirst_data: photoData,
      url_large: this.blankPhotoUrl
    };
  }

  clearRoutineTraceData(current) {
    for (let index in current) {
      if (current[index]?.routineData?.traceVal) {
        delete current[index].routineData.traceVal;
      } else if (current[index]?.attributes?._children) {
        this.clearRoutineTraceData(current[index].attributes._children);
      }
    }
  }

  getRoutineTraceId(current, routineName, routineId, foundData) {
    if (foundData != null) {
      return foundData;
    }
    for (let index in current) {
      if (current[index].routineData) {
        let currentRData = current[index].routineData;
        //if the routine name and id match the parameters, we've find the correct routine so output the corresponding traceVal
        if (currentRData.routineName == routineName && currentRData.routineId == routineId && currentRData.traceVal) {
          foundData = currentRData.traceVal;
          return this.getRoutineTraceId(current, routineName, routineId, foundData);
        }
      } else if (current[index]?.attributes?._children && Object.keys(current[index]?.attributes?._children).length > 0) {
        return this.getRoutineTraceId(current[index].attributes._children, routineName, routineId);
      }
    }
  }

  routineToMarker(routine, index, parent, placementData, isChild, setData) {
    var newData = Object.assign({}, routine.attributes);
    if (routine._key) newData._key = routine._key;
    for (let key in newData) {
      if (newData[key] === null) {
        delete newData[key];
      }
    }
    if (!isChild && SquashNulls(this.inputModels, routine.type, '_attributes', 'pixel_selection') != '') {
      // if there is no percentY to be found, skip adding the marker for now
      const percentY = this.getMarkerHeightPercentage(routine, placementData, parent);
      if (percentY == null) return;
      newData.pixel_selection = [
        {
          percentX: 50,
          percentY: percentY
        }
      ];
    }

    // ensure that constraint data gets added to the photoData if we are editing a construction spec
    if (this.constructionSpecMode && routine._constraints) newData._constraints = routine._constraints;

    if (routine?.add_to_new_trace || routine?.add_to_trace /* && (this.entryRoutine?.list.length == 0 || !this.entryRoutine)*/) {
      /*Set the currentTraceId: if the current item has routineData, then find trace val based off of routineData, otherwise create a new trace value. 
        -Note: for items with add_to_new_trace, a new trace id will always be created and committed */
      //create new traceId
      let currentTraceId;
      if (routine.add_to_trace && routine.routineData) {
        //find active trace for this specific routine.  If it's not found, then create a new trace val and commit it to routineData to be found in subsequent calls
        let routineTraceId = this.getRoutineTraceId(this._itemData.items, routine.routineData.routineName, routine.routineData.routineId);
        if (routineTraceId) {
          currentTraceId = routineTraceId;
        } else {
          //increment count once the new id is set
          this.traceCount++;
          currentTraceId = 't' + this.traceCount;
          //update routineData so it can found in subsequent calls for markers that are apart of the same routine
          routine.routineData['traceVal'] = currentTraceId;
        }
      } else if (routine.add_to_new_trace) {
        //increment count once the new id is set
        this.traceCount++;
        currentTraceId = 't' + this.traceCount;
      }

      //set traceData
      let traceData = this.getTraceData(routine.type);
      if (routine.trace_attributes)
        for (var prop in routine.trace_attributes) {
          traceData[prop] = routine.trace_attributes[prop];
        }

      //commit trace
      newData._trace = currentTraceId;
      this.localTraceListeners.traceData[currentTraceId] = traceData;
      //update global traceListeners
      this.traceListeners = Path.copy(this.localTraceListeners);
    }

    if (newData._children && Object.keys(newData._children).length > 0) {
      newData._children = {};
      routine.attributes._children.forEach((item, i) =>
        this.routineToMarker(item, index + '-' + i, newData._children, placementData, true)
      );
    }
    let id = 'i-' + index;
    if (setData) {
      var path = 'photoData.photofirst_data.' + routine.type;
      if (this.get(path)) {
        this.set(path + '.' + id, newData);
      } else {
        this.set(path, { [id]: newData });
      }
    } else {
      parent[routine.type] = parent[routine.type] || {};
      parent[routine.type][id] = newData;
    }
  }

  /**
   * Return a marker's height percentage adjusted by the relative distance
   * @param {number} relativeDistance - The distance to add to the marker
   * @param {number} markerHeightPercentage - The height percentage of the marker to adjust
   * @param {object} conversionData - Data to convert between inches and percentages
   * @returns {number|undefined} - The marker's height percentage adjusted by the relative distance
   */
  getRelativeDistancePercentageToMarker(relativeDistance, markerHeightPercentage, conversionData) {
    // get data for conversion
    const { poleHeightInInches, poleTopPercentageFromBottom, poleGroundPercentageFromBottom } = conversionData;

    // make sure we have the proper data
    if (isNaN(markerHeightPercentage)) return;
    if ([poleHeightInInches, poleTopPercentageFromBottom, poleGroundPercentageFromBottom].some((measurement) => measurement == null))
      return;
    const differenceBetweenTopAndBottom = poleTopPercentageFromBottom - poleGroundPercentageFromBottom;

    // convert the marker percentage to a inches using the pole data
    const markerHeightInInches =
      ((markerHeightPercentage - poleGroundPercentageFromBottom) / differenceBetweenTopAndBottom) * poleHeightInInches;

    // add the relative distance to that marker's height
    const adjustedMarkerHeightInInches = markerHeightInInches - relativeDistance;

    // convert the adjusted height by to a percentage and return it
    const adjustedMarkerHeightPercentageFromBottom =
      (adjustedMarkerHeightInInches / poleHeightInInches) * differenceBetweenTopAndBottom + poleGroundPercentageFromBottom;
    return 100 - adjustedMarkerHeightPercentageFromBottom;
  }

  /**
   * Get the proper height percentage of a routine item to place on the routine viewer
   * @param {object} marker - The marker to get the height percentage of
   * @param {object} placementData - Data used to facilitate marker placement across all markers
   * @param {object} currentPhotoData - The photoData as it's being built
   * @returns {number|undefined} - The height percentage to put the current marker
   */
  getMarkerHeightPercentage(marker, placementData, currentPhotoData) {
    // Should place marker's using relative distance
    const placingRelativeMarkers = placementData.placingMarkersWithRelativeDistance;
    if (placingRelativeMarkers) {
      // get the height percentage of the "relative_to_index" marker
      let relativeToIndexMarkerPercentage;
      const relativeToIndex = marker.relative_to_index;
      // if the "relative_to_index" marker is the pole top, get the percentage from the placement data
      if (relativeToIndex == '$POLE_TOP') relativeToIndexMarkerPercentage = 100 - placementData.poleTopPercentageFromBottom;
      else {
        // find the data for the "relative_to_index" marker
        const relativeToItemType = this._itemData?.items?.[relativeToIndex]?.type;
        const relativeToMarkerData = currentPhotoData?.[relativeToItemType]?.[`i-${relativeToIndex}`];

        // get percentage for the "relative_to_index" marker
        relativeToIndexMarkerPercentage = relativeToMarkerData?.pixel_selection?.[0]?.percentY;
      }
      // height percentages go from top to bottom so flip it so that it can relate to pole height in inches properly
      const relativeToMarkerPercentageFromBottom = 100 - relativeToIndexMarkerPercentage;

      // calculate the adjusted marker height
      const markerRelativeDistance = marker.relative_distance ?? 0;
      const adjustedMarkerHeightPercentage = this.getRelativeDistancePercentageToMarker(
        markerRelativeDistance,
        relativeToMarkerPercentageFromBottom,
        placementData
      );

      // If there is no adjusted height, then queue the marker to be placed with the other manual markers
      if (!adjustedMarkerHeightPercentage) {
        placementData.markersWithoutRelativeDistances.push(marker);
        return;
      }

      // determine if the lowestPlacedMarkerHeightPercentage needs to be changed (the higher the percentage, the lower the marker)
      if (adjustedMarkerHeightPercentage > placementData.lowestPlacedMarkerHeightPercentage)
        placementData.lowestPlacedMarkerHeightPercentage = adjustedMarkerHeightPercentage;

      return adjustedMarkerHeightPercentage;
    }
    // if we are not placing markers with relative heights, place it evenly spaced
    else return this.getManualHeightMarkerPercentage(placementData);
  }

  /**
   * Gets the height percentage of a marker that doesn't have a relative distance
   * @param {object} placementData - Data used to facilitate marker placement across all markers
   */
  getManualHeightMarkerPercentage(placementData) {
    // increment the index of the marker being place manually
    placementData.currentManualHeightMarkerPlacementCount++;

    // get the appropriate placement data
    const lowestPlacedMarkerHeightPercentage = placementData.lowestPlacedMarkerHeightPercentage ?? placementData.poleTopHeightPercentage;
    const totalManualHeightMarkerCount = placementData.markersWithoutRelativeDistances.length;

    // set the bounds of space available to place markers with manual heights
    const bottomofSpaceAvailable = placementData.poleBottomHeightPercentage ?? 100;

    // determine the amount of space to put between markers with manual heights so they are spaced evenly
    const spaceAvailable = bottomofSpaceAvailable - lowestPlacedMarkerHeightPercentage;
    const spaceBetweenManualMarkers = spaceAvailable / (totalManualHeightMarkerCount + 1);

    // calculate the percentage
    const percentage =
      lowestPlacedMarkerHeightPercentage + spaceBetweenManualMarkers * placementData.currentManualHeightMarkerPlacementCount;
    return percentage;
  }

  getTraceData(property) {
    var traceData = {};
    var attributes = SquashNulls(this.traceModels, SquashNulls(this.inputModels, property, '_trace_type'), 'attributes');
    for (var prop in attributes) {
      traceData[prop] = '';
    }
    return traceData;
  }

  tapPhoto(e) {
    if (this.newData) {
      this.runRoutine(e.detail.percentY);
    } else if (!e.detail.deselecting) {
      e.target.setTemporaryInput(e);
    }
    if (this.updateConstraintDetails) {
      this.updateConstraintDetails = null;
      this.$.toast.close();
    }
  }

  emptyAttributesObject(attributes) {
    let emptyAttributes = {};
    for (let key in attributes) {
      if (key != 'pixel_selection') emptyAttributes[key] = '';
    }
    return emptyAttributes;
  }

  hasNewTraceData(routine) {
    for (let item in routine) {
      if (routine[item].add_to_trace) {
        return true;
      }
    }
  }

  getRoutineNameId(rName) {
    let highestId = -1;
    for (let elem in this._itemData.items) {
      if (this._itemData.items[elem]?.routineData?.routineName == rName) {
        let currentId = this._itemData.items[elem].routineData.routineId;
        if (currentId > highestId) {
          highestId = currentId;
        }
      }
    }
    if (highestId == -1) return 0;
    else return highestId + 1;
  }

  newDataChange(e) {
    this.newData.value[e.detail.attribute_name] = e.detail.value;
  }

  chooseNewInput(e) {
    let routineName = e.detail.value;
    routineName = routineName.charAt(0).toUpperCase() + routineName.substr(1);
    let routine = [{}];
    if (this.routines[routineName]?.items) routine = Path.copy(this.routines[routineName].items);
    else if (this.routines[e.detail.value]?.items) {
      routine = Path.copy(this.routines[e.detail.value].items);
      routineName = e.detail.value;
    } else if (this.inputModels[e.detail.value]) {
      let routineObj = this.emptyAttributesObject(this.inputModels[e.detail.value]._attributes) || {};
      routine[0]['attributes'] = routineObj;
      routine[0]['type'] = e.detail.value;
      routineName = null;
    } else {
      routine = [{ type: e.detail.value }];
      routineName = null;
    }

    //if there's not data on the routine or it couldn't find any data on the routine, then do nothing
    if (Object.keys(routine[0]).length > 0) {
      // Change some details if the child is a wire. This needs to be changed inside the normal wire's routine, but not sure how to do that
      // without access to the database!
      if (routine[0].type == 'wire') {
        routine[0] = {
          type: 'wire',
          add_to_new_trace: true,
          trace_attributes: routine[0].trace_attributes || {}
        };
      }
      let y = e.detail.tempInput.y;
      this.entryRoutine = {
        list: []
      };
      this.entryRoutine.list = routine.filter((item) => {
        if (!SquashNulls(this.inputModels[item.type], '_attributes', 'pixel_selection')) {
          this.splice('_itemData.items', 0, 0, item);
          this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
        }
        // filter out pole top markers if this is a construction spec editor
        else if (this.constructionSpecMode && item.type == 'pole_top') return false;
        else return true;
      });

      // if this is a construction spec editor, tell the user that pole tops will be skipped
      if (this.constructionSpecMode) {
        const routineHasPoleTops = routine.some((item) => item.type == 'pole_top');
        if (routineHasPoleTops) {
          this.$.toast.show({
            text: 'Pole Top markers may not be added to construction specs',
            duration: 10000
          });
        }
      }

      //routineName is != null if the name given is not a routine (only want to set a routineName if these elements are part of a routine)
      if (this.hasNewTraceData(routine) && routineName != null) {
        this.entryRoutine['rName'] = routineName;
        this.entryRoutine['rId'] = this.getRoutineNameId(routineName);
      }

      this.runRoutine(y);
    }
  }

  runRoutine(y) {
    if (this.entryRoutine.list.length > 0) {
      let clickPositionIndex = 0;
      for (let property in this.photoData.photofirst_data) {
        for (let itemKey in this.photoData.photofirst_data[property]) {
          let marker = this.photoData.photofirst_data[property][itemKey];
          if (!marker.pixel_selection || marker.pixel_selection[0].percentY < y) {
            clickPositionIndex++;
          }
        }
      }
      let insertItem = this.entryRoutine.list.shift();
      //set routineData if needed (includes routineName and an id if there are multiple items with the same routine)
      if (this.entryRoutine.rId != undefined && this.entryRoutine.rName != undefined) {
        insertItem['routineData'] = {
          routineName: this.entryRoutine.rName,
          routineId: this.entryRoutine.rId
        };
      }
      //add attributes specified in newData to insertItem before it gets added to _itemData
      if (this.newData?.value) {
        for (let propType in this.newData.value) {
          let prop = this.newData.value[propType];
          if (prop != '' && propType != '_children') {
            insertItem.attributes[propType] = prop;
          }
        }
      }

      this.splice('_itemData.items', clickPositionIndex, 0, insertItem);
      this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
    }
    if (this.entryRoutine.list.length > 0) {
      let promptItem = this.entryRoutine.list[0];
      let newData = {};
      for (var key in promptItem.attributes) {
        if (key == '_children') this.getAssembly(promptItem.attributes[key], newData);
        else newData[key] = promptItem.attributes[key];
      }
      this.newData = {
        property: promptItem.type,
        value: newData
      };
    } else {
      this.newData = null;
    }
  }

  // addNewItem(inputType, y, presets) {
  //   var newData = {};
  //   if (this.inputModels[inputType] === true || (this.inputModels[inputType] != null && this.inputModels[inputType]._attributes === true)) {
  //     newData = true
  //   }
  //   else {
  //     if (this.inputModels[inputType] != null && this.routines[inputType] == null) {
  //       for (var key in this.inputModels[inputType]._attributes) {
  //         if (this.inputModels[inputType]._attributes[key].value == null) {
  //           newData[key] = '';
  //         }
  //         else {
  //           newData[key] = this.inputModels[inputType]._attributes[key].value;
  //         }
  //       }
  //       if (SquashNulls(this.inputModels[inputType], '_attributes', 'pixel_selection')) {
  //         newData.pixel_selection = [{percentX:50, percentY:y}]
  //       }
  //     }
  //     for (var key in presets) {
  //       if (key == '_children') this.getAssembly(presets[key], newData);
  //       else newData[key] = presets[key];
  //     }
  //   }

  //   var id = 'i' + this.counter++;
  //   var path = 'photoData.photofirst_data.' + inputType;
  //   if (this.get(path)) {
  //     this.set(path + '.' + id, newData);
  //   }
  //   else {
  //     this.set(path, {[id]:newData})
  //   }

  //   if (newData.pixel_selection) {
  //     setTimeout(() => {
  //       this.$.viewer.selectAnnotation(inputType, id, inputType, id)
  //     })
  //   }

  //   return newData;
  // }

  getAssembly(children, obj) {
    if (Array.isArray(children)) {
      for (let i = children.length - 1; i >= 0; i--) {
        let item = children[i];
        if (item && item.type && this.inputModels[item.type]) {
          let key = FirebaseWorker.ref().push().key;
          let c = (obj._children = obj._children || {});
          let t = (c[item.type] = c[item.type] || {});
          let x = (t[key] = t[key] || {});
          if (item.add_to_new_trace && this.inputModels && this.inputModels[item.type] && this.inputModels[item.type]._trace_type) {
            let traceType = this.inputModels[item.type]._trace_type,
              trace = FirebaseWorker.ref().push().key,
              model = this.traceModels[traceType].attributes,
              update = { _trace_type: traceType, label: '' };
            x._trace = trace;
            for (let z in model) {
              update[z] = SquashNulls(item, 'trace_attributes', z);
            }
            if (SquashNulls(item, 'trace_attributes', 'proposed') === true) {
              update['proposed'] = true;
            }
            // FirebaseWorker.ref('/photoheight/jobs/' + this.jobId + '/traces/trace_data/' + trace).update(update, e => { if (e) this.fire('toast', e); });
          }
          if (item.attributes) {
            for (let attr in item.attributes) {
              if (attr == '_children') this.getAssembly(item.attributes[attr], x);
              else x[attr] = item.attributes[attr];
            }
          } else x._exists = true;
        }
      }
    }
  }

  getPath(itemPath, itemKey) {
    //Swap Id's for proper indices
    let pathSplit = itemPath.split('/').map((x) => (x.includes('-') ? x.split('-').pop() : x));

    //Add the itemKey index
    if (itemKey) {
      pathSplit.push(itemKey.split('-').pop());
    }

    //Remove top property since our routine is stored in an array
    pathSplit.shift();

    let path = '_itemData.items.';
    pathSplit.forEach((x) => {
      if (x == '_children') {
        path += '.attributes._children.';
      } else if (!isNaN(x)) {
        path += x;
      }
    });
    return path;
  }

  setAndBuildPath(knownPath, potentialPathParts, value) {
    while (potentialPathParts.length > 0) {
      // Removed - this.get(knownPath): not sure if this fix is good or will break anything but it works for what I want it to do.
      knownPath += '.' + potentialPathParts.shift();
    }
    this.set(knownPath, Path.set({}, potentialPathParts.join('.'), value).base);
  }

  photoDataChange(e) {
    if (!e.detail.dragging) {
      //get all the markers that are selected
      let multiSelectedMarkers = [];
      let targetMarkers = e.target.markers;
      if (targetMarkers) {
        for (var i = 0; i < targetMarkers.length; i++) {
          if (targetMarkers[i].multiSelected == true) {
            multiSelectedMarkers.push(targetMarkers[i]);
          }
        }
      }
      if (e.detail.attribute_name == 'pixel_selection') {
        let clickPositionIndex = 0;
        for (let property in this.photoData.photofirst_data) {
          for (let itemKey in this.photoData.photofirst_data[property]) {
            let marker = this.photoData.photofirst_data[property][itemKey];
            if (
              itemKey != e.detail.itemKey &&
              (!marker.pixel_selection || marker.pixel_selection[0].percentY < e.detail.value[0].percentY)
            ) {
              clickPositionIndex++;
            }
          }
        }
        let itemIndex = Number(e.detail.itemKey.split('-')[1]);
        if (itemIndex != clickPositionIndex) {
          this.splice('_itemData.items', clickPositionIndex, 0, this.splice('_itemData.items', itemIndex, 1)[0]);
        }
        this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
      } else {
        let path = this.getPath(e.detail.path, e.detail.itemKey);
        if (e.detail.attribute_name) {
          if (!e.detail.top_level) path += '.attributes';
          let value = typeof e.detail.value === 'undefined' ? null : e.detail.value;
          if (this.get(path)) {
            path += '.' + e.detail.attribute_name;
          } else {
            value = { [e.detail.attribute_name]: value };
          }
          Path.set(this, path, value);
          if (value == null) {
            Path.delete(this, path);
            this.getPhotoData();
          }
          this.notifyWholePath(path);

          // Update photoData
          let itemPath = 'photoData.photofirst_data.' + e.detail.path.replaceAll('/', '.') + '.' + e.detail.itemKey;
          if (e.type == 'remove-attribute') {
            //delete item from photofirst_data
            let item = this.get(itemPath);
            delete item[e.detail.attribute_name];
            this.notifyPath(itemPath);
            //delete item from _itemData
            let indexToRemove = Number(e.detail.itemKey.split('-')[1]);
            let itemToRemove = e.detail.attribute_name;
            delete this._itemData.items[indexToRemove].attributes[itemToRemove];
          } else {
            this.deepSet(itemPath + '.' + e.detail.attribute_name, e.detail.value);
          }
        }
        //we want to delete something
        else if (e.detail.value == null) {
          let single = false;
          if (multiSelectedMarkers.length == 0) {
            //if we got here, we're only deleting one item we'll just add a blank marker to multiSelectedMarkers and use the event instead
            single = true;
            multiSelectedMarkers.push({});
          }
          while (multiSelectedMarkers.length > 0) {
            let markerToDelete = multiSelectedMarkers.shift();
            //delete traceData for multi-selected markers
            let startPath, localItemKey;
            if (single) {
              startPath = e.detail.path;
              localItemKey = e.detail.itemKey;
              path = this.getPath(startPath, localItemKey);
            } else {
              startPath = markerToDelete.property;
              localItemKey = markerToDelete.itemKey;
              path = this.getPath(startPath, localItemKey);
            }

            //remove traceData from traceListeners
            let pathArray = startPath.split('/');
            let finalPath = pathArray.join('.');
            finalPath = 'photoData.photofirst_data.' + finalPath + '.' + localItemKey;
            //recursively scan through the children of the item to delete to delete all of their trace values
            let tracesToRemove = this.scanTraceAttributes(null, this.get(finalPath), [], 'getTraces');
            if (tracesToRemove.length > 0) {
              for (let traceIndex in tracesToRemove) {
                delete this.traceListeners.traceData[tracesToRemove[traceIndex]];
              }
            }
            //delete actual marker in _itemData
            let pathSplit = path.split('.');
            let index = Number(pathSplit.pop());
            this.splice(pathSplit.join('.'), index, 1);
            //update itemKeys whose number exceed the index we just deleted from
            this.updateDelete(multiSelectedMarkers, index);

            // Update photo Data
            this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
          }
        } else {
          console.error("data change that should be (but isn't) supported", e);
        }
      }
    }
  }

  updateDelete(array, givenIndex) {
    //loop through the itemKeys of the given array and subtract them by one if they exceed the index given
    for (let index in array) {
      let item = array[index];
      if (item.itemKey) {
        let itemArray = item.itemKey.split('-');
        //get the item number out of the itemKey
        let itemNum = parseInt(itemArray[itemArray.length - 1]);
        if (itemNum > givenIndex) {
          //increment the itemNumber
          itemArray[itemArray.length - 1] = parseInt(itemArray[itemArray.length - 1]) - 1;
          let newItemKey = itemArray.join('-');
          //set the new itemKey for the current element
          array[index].itemKey = newItemKey;
        }
      }
    }
  }

  childAdded(e) {
    let childIndex = Number(e.detail.childKey.split('-')[1]);
    let parentIndex = Number(e.detail.itemKey.split('-')[1]);
    //add "_children" or "attribute" attribute to parent in itemData
    if (!this._itemData?.items[parentIndex]?.attributes) {
      this._itemData.items[parentIndex]['attributes'] = {};
    }
    if (!this._itemData?.items[parentIndex]?.attributes?._children) {
      this._itemData.items[parentIndex].attributes['_children'] = [];
    }

    //add child to parent childIndex
    let routineItem = this._itemData.items[childIndex];
    this.push(`_itemData.items.${parentIndex}.attributes._children`, routineItem);

    //set the index of the new child inside its parent
    let newIndex = this._itemData.items[parentIndex].attributes._children.length - 1;

    // remove the element from photofirst_data
    let itemPath = 'photoData.photofirst_data.' + e.detail.childType;
    let item = this.get(itemPath);
    delete item[e.detail.childKey];
    this.notifyPath(itemPath);

    // add it to the new parent, building out the structure as needed
    this.setAndBuildPath(
      'photoData.photofirst_data.' + e.detail.property + '.' + e.detail.itemKey,
      ['_children', e.detail.childType, e.detail.itemKey + '-' + newIndex],
      e.detail.child
    );
    //delete child item
    this.splice('_itemData.items', childIndex, 1);
    //update itemData keys and photoData
    this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
  }

  childRemoved(e) {
    let path = this.getPath(e.detail.pathToChild, e.detail.itemKey);
    let pathSplit = path.split('.');
    let index = Number(pathSplit.pop());
    let child = this.splice(pathSplit.join('.'), index, 1)[0];
    let newIndex = Number(pathSplit[2]) + 1;
    this.splice('_itemData.items', newIndex, 0, child);

    // Update photo Data
    this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
  }

  /*This method recursively scans thourhg whatever starting array or object you give it and works with trace value.
    It has a "func" property, which specifies what you want to do with the trace data. 
    Function Options:
    -"setTraceAttributes": sets the trace attributes specified in e for each element that has a matching trace val (in e as well)
    -"getTraces": returns an array of all of the trace vals in the starting array / object
    */
  scanTraceAttributes(e, current, carryOver, func) {
    for (let prop in current) {
      let elem = current[prop];
      //for "set..." carryOver is the path, for "get..." carryOver is an array of traces in the element
      if (func == 'getTraces') {
        if (prop == '_trace') {
          carryOver.push(elem);
        } else if (elem?._children && Object.keys(elem?._children).length > 0) {
          this.scanTraceAttributes(e, elem._children, carryOver, func);
        } else if (typeof elem != 'string') {
          this.scanTraceAttributes(e, elem, carryOver, func);
        }
      } else if (func == 'setTraceAttributes') {
        let runningPath = Path.copy(carryOver);
        if (elem?._trace == e.detail.trace) {
          let path = this.getPath(runningPath, prop);
          //add a trace_attributes field if there is none so that the correct data can be added
          if (!this.get(path + '.trace_attributes')) this.set(path + '.trace_attributes', {});
          this.setAndBuildPath(path, ['trace_attributes', e.detail.info.attribute_name], e.detail.info.value);
        }
        if (elem._children && Object.keys(elem._children).length > 0) {
          runningPath += prop + '/_children/';
          this.scanTraceAttributes(e, elem._children, runningPath, func);
        }
        //elem will be a string if it reaches an attribute, which means there's no more children.  Exit when this happens or we find a trace value
        else if (typeof elem != 'string' && !elem._trace) {
          runningPath += prop + '/';
          this.scanTraceAttributes(e, elem, runningPath, func);
        }
      }
    }

    //specify return values here if needed
    if (func == 'getTraces') {
      return carryOver;
    }
  }

  traceChange(e) {
    //update all instances of the trace in itemData using photofirst data
    this.scanTraceAttributes(e, this.photoData.photofirst_data, '', 'setTraceAttributes');
    this.set('traceListeners.traceData.' + e.detail.trace + '.' + e.detail.info.attribute_name, e.detail.info.value);
  }

  removeTrace(e, skipPhotoUpdate) {
    let path = this.getPath(e.detail.path, e.detail.key);
    let item = this.get(path);
    delete item.add_to_new_trace;
    delete item.add_to_trace;
    delete item.trace_attributes;
    this.notifyPath(path);

    if (skipPhotoUpdate !== true) {
      this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
    }
  }

  deleteTrace(e) {
    TraverseMarkers(this.photoData.photofirst_data, (child, path, childProperty, childItemKey) => {
      if (child._trace == e.detail.trace) {
        this.removeTrace(
          {
            detail: {
              path,
              key: childItemKey
            }
          },
          true
        );
      }
    });
    this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
  }

  startTrace(e) {
    this.tracing = true;
    this.traceList = [];
    this.$.viewer.markers.forEach((item, i) => {
      this.disableIfNotTracable(item.marker, i, item.property, 'parent');
      RunOnChildren(item.marker, (child, path, childProperty, childItemKey) => {
        this.disableIfNotTracable(child, i, childProperty, childItemKey);
      });
    });
  }

  markerSelected(e) {
    if (this.tracing) {
      let path = this.getPath(e.detail.path, e.detail.itemKey);
      if (e.detail.property == 'wire') {
        this.set(path + '.add_to_new_trace', true);
        this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
      } else if ((e.detail.property == 'guying' || e.detail.property == 'equipment') && e.detail.property == e.detail.path) {
        this.set(path + '.add_to_trace', SquashNulls(this.inputModels, e.detail.property, '_trace_type'));
        this.getPhotoData(this._itemData, this.inputModels, this.traceModels);
      }
    } else if (this.updateConstraintDetails) {
      let key = this.get(`photoData.photofirst_data.${e.detail.property}.${e.detail.itemKey}._reference_key`);
      // If we didnt have a key, set it on the clicked item
      if (!key) {
        key = e.detail.property == 'pole_top' ? '$POLE_TOP' : FirebaseWorker.ref().push().key;
        this.photoDataChange({
          target: this.$.viewer,
          detail: {
            property: e.detail.property,
            itemKey: e.detail.itemKey,
            path: e.detail.path,
            attribute_name: '_reference_key',
            value: key,
            top_level: true
          }
        });
      }
      this.updateConstraintDetails.value = key;
      this.photoDataChange({ target: this.$.viewer, detail: this.updateConstraintDetails });
      this.getPhotoData();
      this.updateConstraintDetails = null;
      this.$.viewer.clearSelectedAnnotation();
      this.$.toast.close();
    }
  }

  finishTrace(e) {
    this.tracing = false;
    this.updateConstraintDetails = null;
    this.$.viewer.markers.forEach((item, i) => {
      this.$.viewer.set('markers.' + i + '.disabled', {});
    });
  }

  disableIfNotTracable(marker, i, property, itemKey) {
    if (!SquashNulls(this.inputModels, property, '_trace_type') || marker._trace) {
      this.$.viewer.set('markers.' + i + '.disabled.' + itemKey, true);
    }
  }

  toolsetSelectedChanged(e) {
    if (e.detail.value) {
      e.currentTarget.value = null;
      if (!this.get('_itemData.toolsets')) this.set('_itemData.toolsets', { [e.detail.value]: true });
      else this.set(`_itemData.toolsets.${e.detail.value}`, true);
    }
  }
  _itemDataChanged(changeRecord) {
    super._itemDataChanged.apply(this, arguments);
    // Only update toolsArray when the entire _itemData object is changed.
    if (changeRecord.base != null && !Array.isArray(changeRecord.base.items)) this.set('_itemData.items', []);

    // Check for base being an array
    if (!changeRecord.base?.items?.length && Array.isArray(changeRecord.base)) {
      // If it is, we need to convert these models
      const items = changeRecord.base.slice();
      this.set('_itemData', {
        $key: changeRecord.base.$key,
        $label: changeRecord.base.$label,
        items
      });
    }
  }

  removeFromToolset(e) {
    delete this._itemData.toolsets[e.model.item.$key];
    this.notifyPath('_itemData.toolsets');
  }

  async _saveUpdate(itemData, update, detail) {
    const routineExampleImagesRef = firebase.storage().ref(`company_files/${this.userGroup}/routine_example_images`);

    // Helper function to delete an old example photo
    const deleteOldExamplePhoto = async (photoId) => {
      try {
        await routineExampleImagesRef.child(photoId).delete();
      } catch (error) {
        this.$.toast.show({
          text: `We couldn't delete the old example photo, contact support if this issue persists`,
          duration: 5000
        });
        console.error(error);
      }
    };

    if (this.constructionSpecMode) {
      const previousExamplePhotoId = this.itemData?.example_photo_id;
      const shouldDeleteOldPhoto = previousExamplePhotoId && itemData?.example_photo_id == null;

      if (shouldDeleteOldPhoto) await deleteOldExamplePhoto(previousExamplePhotoId);

      if (itemData?.file) {
        let key = FirebaseWorker.ref().push().key;
        await routineExampleImagesRef.child(key).put(itemData.file);
        itemData.example_photo_id = key;
        delete itemData.file;
      }
    } else {
      // Get a list of the new example photo keys
      const newPhotoKeys = {};
      itemData?.icons?.forEach((icon) => (newPhotoKeys[icon.photo] = true));

      // Delete old photos that were removed  (looping over this.itemData because it is the old copy of the data)
      if (this.itemData?.icons) {
        for (let icon of this.itemData.icons) {
          if (icon.photo && !newPhotoKeys[icon.photo]) await deleteOldExamplePhoto(icon.photo);
        }
      }

      // Upload the file if we have a new one
      if (itemData?.file) {
        let key = itemData?.icons?.find((icon) => icon.photo)?.photo;
        if (key) await routineExampleImagesRef.child(key).put(itemData.file);
        delete itemData.file;
      }
    }

    // Save the item
    await super._saveUpdate(itemData, update, detail);

    // Update all of the toolsets.
    await FirebaseWorker.ref(`${this.modelSpaceDetails.path}/models/input_model_groups`).transaction((toolsets) => {
      if (toolsets) {
        let itemKey = detail.itemKey;
        // If we are in construction spec mode, we need to set the item key to be the routine key
        if (this.constructionSpecMode) {
          itemKey = itemData?.routine_key;
          // If we are deleting the construction spec then use the routine key that was deleted since item data will be null
          if (this.routineKeyToDelete) {
            itemKey = this.routineKeyToDelete;
            this.routineKeyToDelete = null;
          }
        }

        for (let key in toolsets) {
          let add = Path.get(itemData, `toolsets.${key}`) != null && toolsets[key][itemKey] == null;
          let remove = Path.get(itemData, `toolsets.${key}`) == null && toolsets[key][itemKey] != null;
          // Get the toolset being modified.
          let toolset = toolsets[key];
          if (add || remove || detail.keyChanged) {
            // If the tool's key has changed, remove references to it's previous key.
            if (detail.keyChanged) delete toolset[detail.previousKey];
            // If we are removing the item from the toolset, go ahead and do that now.
            if (remove) delete toolset[itemKey];
            if (add) {
              toolset[itemKey] = { _include_in_single_click: true };
            }
          }
        }
        return toolsets;
      }
    });
  }

  /**
   * @returns {boolean} True if the item has a file associated with it.
   */
  hasExampleImage() {
    const hasUnsavedLocalFile = this._itemData?.file;
    const hasSavedRoutineFile = !this.constructionSpecMode && this._itemData?.icons?.find((icon) => icon.photo);
    const hasSavedConstructionSpecFile = this.constructionSpecMode && this._itemData?.example_photo_id;
    return hasUnsavedLocalFile || hasSavedRoutineFile || hasSavedConstructionSpecFile;
  }

  openImageInput() {
    this.$.imageInput.click();
  }

  async imageFileSelected(e) {
    let file = e.target.files[0];
    if (file) {
      this.set('_itemData.file', file);
      if (!this.constructionSpecMode)
        this.set('_itemData.icons', [{ icon: 'image:photo', photo: FirebaseWorker.ref().push().key, size: 24 }]);
    }
    e.currentTarget.value = null;
  }

  async getExampleImage() {
    // Handle local files that have not been uploaded yet
    if (this._itemData?.file) return URL.createObjectURL(this._itemData.file);

    const photoKey = this.constructionSpecMode
      ? this._itemData?.example_photo_id
      : this._itemData?.icons?.find((icon) => icon.photo)?.photo;
    if (!photoKey) return;

    return await globalThis.firebase.storage().ref(`company_files/${this.userGroup}/routine_example_images/${photoKey}`).getDownloadURL();
  }

  async openImageFile() {
    const url = await this.getExampleImage();
    // Open it in a new window
    if (url) window.open(url);
  }

  async updateExampleImagePreviewSrc() {
    const url = await this.getExampleImage();
    this.exampleImagePreviewSrc = url;
  }

  removeImageFile() {
    // Handle both construction spec mode and routine mode
    if (this.constructionSpecMode) {
      this.set('_itemData.example_photo_id', null);
    } else {
      let photoIndex = this._itemData?.icons?.findIndex((icon) => icon.photo);
      if (photoIndex != null && photoIndex != -1) {
        this.splice('_itemData.icons', photoIndex, 1);
      }
    }

    // Clear the local file
    this.set('_itemData.file', null);
  }

  openKLogicEditor(e) {
    this.kLogicDialogInfo = e.detail;
    this.kLogicDialogCallback = e.detail.callback;
    this.$.kLogicEditorDialog.open();
  }

  kLogicDialogConfirm(e) {
    this.kLogicDialogCallback(this.kLogicDialogInfo.block);
  }

  promptConstraintRelativeToSelection(e) {
    this.updateConstraintDetails = e.detail;
    this.$.toast.show({ text: 'Select a marker to constrain to', duration: Infinity });
  }

  showKLogicButton() {
    return this.constructionSpecMode && this.enabledFeatures.custom_logic_routine_values === true;
  }

  tagSelectorChangeHandler(e) {
    const tags = e.target.tags;
    this.set('_itemData.tags', tags);
  }
}

customElements.define('katapult-routine-editor', KatapultRoutineEditor);
